
<app-generic-grid #grid
                  (rowToRestore)="restoreProduct($event)">
</app-generic-grid>
